export default __webpack_public_path__ + "static/media/chart-teaser__light.0159fe0c22f98bdbfb29ed78032a8a98.svg";